<div class="field-grid">
    <ng-content select="[top]"></ng-content>
    <ng-content></ng-content>
    <ng-content select="[bottom]"></ng-content>
</div>
